let language = {
    DASHBOARD_GUIDE_TITLE: "欢迎来到  {{appName}}, 让我们开始吧：",
    DASHBOARD_GUIDE_STEP_1: "步骤 1",
    DASHBOARD_GUIDE_STEP_2: "步骤 2",
    DASHBOARD_GUIDE_STEP_3: "步骤 3",
    DASHBOARD_GUIDE_STEP_4: "步骤 4",
    DASHBOARD_GUIDE_STEP_5: "步骤 5",
    DASHBOARD_GUIDE_STORE: "将您的商店与{{appName}}连接起来",
    DASHBOARD_GUIDE_STORE_DES: "轻松将您的 Woo commerce 或 Shopify 商店与{{appName}} 集成。同步产品并轻松开始销售。",
    DASHBOARD_GUIDE_STORE_PRODUCT: "将产品添加到您的商店",
    DASHBOARD_GUIDE_STORE_PRODUCT_DES: "使用我们的设计工具添加定制产品。设定价格并撰写引人注目的描述。",
    DASHBOARD_GUIDE_SAMPLE_ORDER: "订购样品",
    DASHBOARD_GUIDE_SAMPLE_ORDER_DES: "在销售前订购样品以检查定制产品的质量、颜色和材料",

    DASHBOARD_GUIDE_CUSTOMER_ORDER: "检查客户订单",
    DASHBOARD_GUIDE_CUSTOMER_ORDER_DES: "监控收到的订单、查看详细信息并确保订单准确性。",

    DASHBOARD_GUIDE_COMBINE_ORDER: "拼单",
    DASHBOARD_GUIDE_COMBINE_ORDER_DES: "有效地拼单以节省产品成本并简化物流。",

    DASHBOARD_GUIDE_START_BTN: "开始",
    DASHBOARD_GUIDE_PAGE_LOADING_TITLE: "页面记载异常",
    DASHBOARD_GUIDE_PAGE_LOADING_CONTENT: "加载此页时发生问题。 请刷新页面再试一次。 如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}。",

};

export { language }